import SurveyClosed from './SurveyClosed';

export default SurveyClosed;
